module.exports = __webpack_public_path__ + "media/images/orbit/left-arrow-half-size-39a5c6a524260f13499276c24b88bcd729c16a44ff903264649f71e534838063.png";